import motoSidewall from '../../../Assets/technical_info/moto_tire_sidewall.png'

const TechnicalLV4 = () => {
    return (
        <div>
            <p><span style={ { fontSize: "24px" } }><strong>Tāpat kā transportlīdzekļiem ar četriem riteņiem, arī motociklu riepām izmēru nosaka riepas kods, kas norāda riepas platumu, profila attiecību, konstrukcijas tipu, diametru, slodzes indeksu un ātruma indeksu.</strong></span></p>

            <p>&nbsp;</p>

            <p><img alt="" src={motoSidewall} style={ { width: "min(100%, 600px)", height: "auto", display: "block", margin: "auto" } } /></p>

            <p>&nbsp;</p>

            <ul>
                <li><strong>"120"</strong> - Riepas platums, mm</li>
                <li><strong>"60"</strong> - Riepas profila attiecība, % (riepas sānu malas augstums ir 60% no riepas platuma)</li>
                <li><strong>"R"</strong> - Radiālās riepas konstrukcijas apzīmējums</li>
                <li><strong>"17"</strong> - Diska diametrs, collās</li>
                <li><strong>"55"</strong> - Slodzes indekss (maksimālā nestspēja 218 kg uz vienu riepu)</li>
                <li><strong>"W"</strong> - Ātruma indekss (maksimāli pieļaujamais ātrums līdz 270 km/h)</li>
            </ul>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Svarīgi ir ievērot riepu iebraukšanu un nodilumu:</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Jaunu riepu virsma sākumā var būt gludāka, jo pēc ražošanas uz tās var būt saglabājušās veidnes atdalīšanas līdzekļa paliekas. Tāpēc pirmajos kilometros ieteicams braukt vienmērīgi un izvairīties no straujas paātrināšanās, asas bremzēšanas un lieliem slīpuma leņķiem.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Pirms pilnībā izmantot jauno riepu potenciālu, ieteicams nobraukt vismaz dažus desmitus kilometru, lai riepas un braucējs pie tām pielāgotos.</p>

            <p>&nbsp;</p>
            
            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Jūsu riepas ir aprīkotas ar nodiluma indikatoru. Negaidiet, līdz nodilums kļūst pārāk izteikts, jo tas palielina akvaplanēšanas risku un samazina saķeri, īpaši uz slapja seguma.</p>

            <p>&nbsp;</p>
            
            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Pat tad, ja riepu nodilums pēc vairākām sezonām ir neliels, taču tās uzrāda novecošanās pazīmes, riepas ieteicams nomainīt, jo gumijas īpašības un kopējā veiktspēja ar laiku pasliktinās.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Kā arī Tireshop speciālisti veic ātru un kvalitatīvu moto riepu montāžu. Piesakies!</p>

        </div>
    );
};

export default TechnicalLV4;


